import { EVENTS } from '../../../../../library';

export const TRANSLATION_PATH = (route) => {
  return `views.app.assessments.cyberAssessment.${route}`;
};

export const LOG_EVENT_PATH = (event) => {
  return EVENTS.VIEWS.APP.ASSESSMENTS.CYBER_ASSESSMENT[event];
};
